/**
 * MM Package Builder — scratch flow, live pricing, product popup, cart return
 */
(function () {
  'use strict';

  var root = document.getElementById('mm-package-builder');
  if (!root) return;

  var LANG = (root.dataset.lang || 'en').indexOf('ar') === 0 ? 'ar' : 'en';
  var IS_AR = LANG === 'ar';
  var homeUrl = root.dataset.homeUrl || '/';
  var defaultSlug = root.dataset.defaultSlug || 'build-your-stack';
  var logoUrl = root.dataset.logo || '';

  var state = {
    builder: null,
    settings: {},
    phase: 'qty',
    catIndex: 0,
    pickIndex: 0,
    quantities: {},
    selections: [],
    price: null,
    offerId: null,
    loadingPrice: false,
    adding: false,
  };

  var productCache = {};

  function t(en, ar) {
    return IS_AR ? ar : en;
  }

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function getSlug() {
    var p = new URLSearchParams(window.location.search);
    return p.get('slug') || defaultSlug;
  }

  function getCountry() {
    if (window.MM_MARKETS && window.MM_MARKETS.country) return window.MM_MARKETS.country;
    if (window.Shopify && window.Shopify.country) return window.Shopify.country;
    return 'BH';
  }

  function apiUrl(path) {
    return '/apps/mm-app/api/' + path;
  }

  function formatMoney(minor) {
    var cents = minor;
    if (window.mmTaxConfig && typeof window.mmTaxConfig.formatWithTax === 'function') {
      return window.mmTaxConfig.formatWithTax(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BHD';
    var dec = c === 'BHD' || c === 'KWD' || c === 'OMR' ? 3 : 2;
    return (minor / 1000).toFixed(dec) + ' ' + c;
  }

  function extractId(id) {
    return String(id || '').split('/').pop();
  }

  function categories() {
    return (state.builder && state.builder.scratch && state.builder.scratch.categories) || [];
  }

  function totalPicksNeeded() {
    var total = 0;
    categories().forEach(function (cat) {
      total += state.quantities[cat.id] || 0;
    });
    return total;
  }

  function buildPickQueue() {
    var queue = [];
    categories().forEach(function (cat) {
      var qty = state.quantities[cat.id] || 0;
      for (var i = 0; i < qty; i++) {
        queue.push({ categoryId: cat.id, slotIndex: i, category: cat });
      }
    });
    return queue;
  }

  function currentPick() {
    var queue = buildPickQueue();
    return queue[state.pickIndex] || null;
  }

  function selectionsForPrice() {
    return state.selections.map(function (s) {
      return { categoryId: s.categoryId, variantId: s.variantId, qty: 1 };
    });
  }

  function pickTierForCount(tiers, itemCount) {
    var count = Math.max(0, parseInt(String(itemCount), 10) || 0);
    var picked = null;
    (tiers || []).forEach(function (tier) {
      if (count >= tier.minItems) picked = tier;
    });
    return picked;
  }

  function buildAllowedMap() {
    var map = new Map();
    categories().forEach(function (cat) {
      (cat.products || []).forEach(function (p) {
        (p.variants || []).forEach(function (v) {
          map.set(String(v.id), {
            categoryId: cat.id,
            variantId: String(v.id),
            handle: p.handle,
            priceMinor: v.priceMinor,
          });
        });
      });
    });
    return map;
  }

  function calculatePriceLocal() {
    var allowed = buildAllowedMap();
    var tiers = (state.builder && state.builder.pricingTiers) || [];
    var subtotalMinor = 0;
    var itemCount = 0;
    var lines = [];

    state.selections.forEach(function (sel) {
      var allowedLine = allowed.get(String(extractId(sel.variantId)));
      if (!allowedLine) return;
      var lineTotal = allowedLine.priceMinor;
      subtotalMinor += lineTotal;
      itemCount += 1;
      lines.push({
        categoryId: sel.categoryId,
        variantId: allowedLine.variantId,
        handle: allowedLine.handle,
        qty: 1,
        unitMinor: allowedLine.priceMinor,
        lineMinor: lineTotal,
      });
    });

    var tier = pickTierForCount(tiers, itemCount);
    var discountPercent = tier ? tier.discountPercent : 0;
    var discountMinor = Math.round(subtotalMinor * (discountPercent / 100));
    return {
      success: true,
      itemCount: itemCount,
      subtotalMinor: subtotalMinor,
      discountPercent: discountPercent,
      discountMinor: discountMinor,
      finalMinor: Math.max(0, subtotalMinor - discountMinor),
      tier: tier,
      lines: lines,
    };
  }

  function loadEmbeddedBuilder() {
    var el = document.getElementById('mm-pkg-embedded');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent || '');
      if (!data || !data.builder) return null;
      var cats = data.builder.scratch && data.builder.scratch.categories;
      var hasProducts = cats && cats.length && cats[0].products && cats[0].products.length;
      if (!hasProducts) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function applyBuilderPayload(data) {
    state.builder = data.builder;
    state.settings = data.settings || {};
    state.offerId = data.builder.id;
    if (data.builder.ui && data.builder.ui.accentColor) {
      document.documentElement.style.setProperty('--mm-pkg-accent', data.builder.ui.accentColor);
    }
    categories().forEach(function (cat) {
      if (state.quantities[cat.id] == null) state.quantities[cat.id] = 0;
    });
  }

  async function fetchBuilder() {
    var embedded = loadEmbeddedBuilder();
    if (embedded) {
      applyBuilderPayload(embedded);
      return;
    }

    var slug = getSlug();
    var country = getCountry();
    var res = await fetch(apiUrl('package-builder') + '?slug=' + encodeURIComponent(slug) + '&country=' + encodeURIComponent(country));
    if (!res.ok) throw new Error('Builder not found');
    var data = await res.json();
    if (!data.success || !data.builder) throw new Error(data.error || 'Load failed');
    applyBuilderPayload(data);
  }

  async function refreshPrice() {
    if (!state.selections.length) {
      state.price = null;
      renderBar();
      return;
    }
    state.loadingPrice = true;
    renderBar();
    try {
      var res = await fetch(apiUrl('package-price'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          slug: getSlug(),
          country: getCountry(),
          selections: selectionsForPrice(),
        }),
      });
      if (res.ok) {
        var data = await res.json();
        if (data.success) {
          state.price = data;
          state.loadingPrice = false;
          renderBar();
          if (state.phase === 'summary') renderSummary();
          return;
        }
      }
      state.price = calculatePriceLocal();
    } catch (e) {
      state.price = calculatePriceLocal();
    }
    state.loadingPrice = false;
    renderBar();
    if (state.phase === 'summary') renderSummary();
  }

  function setSelection(categoryId, slotIndex, product, variantId) {
    state.selections = state.selections.filter(function (s) {
      return !(s.categoryId === categoryId && s.slotIndex === slotIndex);
    });
    state.selections.push({
      categoryId: categoryId,
      slotIndex: slotIndex,
      variantId: extractId(variantId),
      handle: product.handle,
      title: product.title,
      image: product.image,
      variantTitle: (product.variants || []).find(function (v) { return String(v.id) === String(extractId(variantId)); })?.title || '',
    });
    refreshPrice();
  }

  function renderTopbar() {
    var ui = (state.builder && state.builder.ui) || {};
    var backLabel = IS_AR ? (ui.backAr || 'العودة للمتجر') : (ui.backEn || 'Back to store');
    var logoHtml = logoUrl ? '<div class="mm-pkg-logo"><img src="' + logoUrl + '" alt=""></div>' : '<div></div>';
    return (
      '<div class="mm-pkg-topbar">' +
        '<a href="' + homeUrl + '" class="mm-pkg-back">' + backLabel + '</a>' +
        logoHtml +
      '</div>'
    );
  }

  function renderProgress() {
    var cats = categories();
    var html = '<div class="mm-pkg-progress">';
    cats.forEach(function (cat, i) {
      var cls = 'mm-pkg-progress-dot';
      if (state.phase === 'qty' && i < state.catIndex) cls += ' is-done';
      if (state.phase === 'qty' && i === state.catIndex) cls += ' is-active';
      if (state.phase !== 'qty' && i <= state.catIndex) cls += ' is-done';
      html += '<div class="' + cls + '"></div>';
    });
    if (state.phase === 'pick' || state.phase === 'summary') {
      html += '<div class="mm-pkg-progress-dot is-active"></div>';
    }
    html += '</div>';
    return html;
  }

  function renderQtyStep() {
    var cat = categories()[state.catIndex];
    if (!cat) return renderSummary();
    var label = IS_AR ? (cat.labelAr || cat.labelEn) : (cat.labelEn || cat.id);
    var maxQ = cat.maxQty || 0;
    var html =
      '<div class="mm-pkg-content">' +
        '<h2 class="mm-pkg-step-title">' + t('How many?', 'كم تريد؟') + ' ' + label + '</h2>' +
        '<p class="mm-pkg-step-sub">' + t('Choose quantity (0–' + maxQ + ')', 'اختر الكمية (0–' + maxQ + ')') + '</p>' +
        '<div class="mm-pkg-qty-grid">';
    for (var q = 0; q <= maxQ; q++) {
      var sel = (state.quantities[cat.id] || 0) === q ? ' is-selected' : '';
      html += '<button type="button" class="mm-pkg-qty-btn' + sel + '" data-qty="' + q + '">' + q + '</button>';
    }
    html += '</div><div class="mm-pkg-nav-row">';
    if (state.catIndex > 0) {
      html += '<button type="button" class="mm-pkg-nav-btn" data-nav="prev-cat">' + t('Back', 'رجوع') + '</button>';
    }
    html += '<button type="button" class="mm-pkg-nav-btn mm-pkg-nav-btn--primary" data-nav="next-cat">' + t('Continue', 'متابعة') + '</button>';
    html += '</div></div>';
    return html;
  }

  function renderPickStep() {
    var pick = currentPick();
    if (!pick) {
      state.phase = 'summary';
      return renderSummary();
    }
    var cat = pick.category;
    var label = IS_AR ? (cat.labelAr || cat.labelEn) : (cat.labelEn || cat.id);
    var slotNum = pick.slotIndex + 1;
    var total = state.quantities[cat.id] || 0;
    var products = cat.products || [];
    var existing = state.selections.find(function (s) {
      return s.categoryId === pick.categoryId && s.slotIndex === pick.slotIndex;
    });

    var html =
      '<div class="mm-pkg-content">' +
        '<h2 class="mm-pkg-step-title">' + label + ' #' + slotNum + ' ' + t('of', 'من') + ' ' + total + '</h2>' +
        '<p class="mm-pkg-step-sub">' + t('Pick your product', 'اختر منتجك') + '</p>' +
        '<div class="mm-pkg-products">';

    products.forEach(function (p) {
      var isSel = existing && existing.handle === p.handle;
      var priceLabel = p.priceMinMinor === p.priceMaxMinor
        ? formatMoney(p.priceMinMinor)
        : formatMoney(p.priceMinMinor) + ' – ' + formatMoney(p.priceMaxMinor);
      var variants = p.variants || [];
      var variantSelect = '';
      if (variants.length > 1) {
        variantSelect = '<select class="mm-pkg-variant-select" data-handle="' + p.handle + '">';
        variants.forEach(function (v) {
          variantSelect += '<option value="' + v.id + '">' + (v.title || 'Default') + '</option>';
        });
        variantSelect += '</select>';
      }
      html +=
        '<div class="mm-pkg-card' + (isSel ? ' is-selected' : '') + '" data-handle="' + p.handle + '">' +
          '<div class="mm-pkg-card__img"><img src="' + (p.image || '') + '" alt="" loading="lazy"></div>' +
          '<div class="mm-pkg-card__body">' +
            '<p class="mm-pkg-card__title">' + p.title + '</p>' +
            '<p class="mm-pkg-card__price">' + priceLabel + '</p>' +
            variantSelect +
            '<div class="mm-pkg-card__actions">' +
              '<button type="button" class="mm-pkg-card__btn mm-pkg-card__btn--info" data-info="' + p.handle + '">' + t('Info', 'معلومات') + '</button>' +
              '<button type="button" class="mm-pkg-card__btn mm-pkg-card__btn--pick" data-pick="' + p.handle + '">' + t('Select', 'اختيار') + '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    });

    html += '</div><div class="mm-pkg-nav-row">';
    if (state.pickIndex > 0) {
      html += '<button type="button" class="mm-pkg-nav-btn" data-nav="prev-pick">' + t('Back', 'رجوع') + '</button>';
    }
    var queue = buildPickQueue();
    if (state.pickIndex < queue.length - 1 && existing) {
      html += '<button type="button" class="mm-pkg-nav-btn mm-pkg-nav-btn--primary" data-nav="next-pick">' + t('Next', 'التالي') + '</button>';
    } else if (existing) {
      html += '<button type="button" class="mm-pkg-nav-btn mm-pkg-nav-btn--primary" data-nav="to-summary">' + t('Review package', 'مراجعة البكج') + '</button>';
    }
    html += '</div></div>';
    return html;
  }

  function renderSummary() {
    var html =
      '<div class="mm-pkg-content">' +
        '<h2 class="mm-pkg-step-title">' + t('Your package', 'بكتك') + '</h2>' +
        '<p class="mm-pkg-step-sub">' + t('Review before adding to cart', 'راجع قبل الإضافة للسلة') + '</p>' +
        '<div class="mm-pkg-summary">';

    if (!state.selections.length) {
      html += '<p>' + t('No items selected', 'لم تختر منتجات بعد') + '</p>';
    } else {
      state.selections.forEach(function (s) {
        html +=
          '<div class="mm-pkg-summary-item">' +
            '<img src="' + (s.image || '') + '" alt="">' +
            '<div class="mm-pkg-summary-item__meta">' +
              '<strong>' + s.title + '</strong>' +
              '<span>' + (s.variantTitle || '') + '</span>' +
            '</div>' +
          '</div>';
      });
    }

    if (state.price && state.price.discountPercent > 0) {
      html += '<div class="mm-pkg-tier-badge">' + t('Save ', 'وفر ') + state.price.discountPercent + '%</div>';
    }

    html += '</div><div class="mm-pkg-nav-row">';
    html += '<button type="button" class="mm-pkg-nav-btn" data-nav="edit-picks">' + t('Edit selections', 'تعديل الاختيارات') + '</button>';
    html += '</div></div>';
    return html;
  }

  function renderBar() {
    var existing = qs('.mm-pkg-bar');
    if (existing) existing.remove();

    var canAtc = state.phase === 'summary' && state.selections.length > 0 && state.price && !state.loadingPrice;
    var ctaLabel = state.adding
      ? t('Adding...', 'جاري الإضافة...')
      : t('Add to cart', 'أضف للسلة');

    var priceHtml = '';
    if (state.price) {
      priceHtml =
        '<div class="mm-pkg-bar__final">' + formatMoney(state.price.finalMinor) + '</div>' +
        '<div class="mm-pkg-bar__sub">' +
          (state.price.discountMinor > 0
            ? '<span class="mm-pkg-bar__save">' + t('Save ', 'وفر ') + formatMoney(state.price.discountMinor) + '</span> · '
            : '') +
          '<s>' + formatMoney(state.price.subtotalMinor) + '</s>' +
        '</div>';
    } else if (state.selections.length) {
      priceHtml = '<div class="mm-pkg-bar__sub">' + t('Calculating...', 'جاري الحساب...') + '</div>';
    }

    var bar =
      '<div class="mm-pkg-bar">' +
        '<div class="mm-pkg-bar__inner">' +
          '<div class="mm-pkg-bar__prices">' + priceHtml + '</div>' +
          '<button type="button" class="mm-pkg-bar__cta" data-atc' + (canAtc && !state.adding ? '' : ' disabled') + '>' + ctaLabel + '</button>' +
        '</div>' +
      '</div>';
    root.insertAdjacentHTML('beforeend', bar);
  }

  function renderPopup() {
    if (qs('.mm-pkg-popup')) return;
    root.insertAdjacentHTML(
      'beforeend',
      '<div class="mm-pkg-popup" hidden role="dialog" aria-modal="true">' +
        '<div class="mm-pkg-popup__backdrop" data-close-popup></div>' +
        '<div class="mm-pkg-popup__panel">' +
          '<button type="button" class="mm-pkg-popup__close" data-close-popup aria-label="Close">×</button>' +
          '<div class="mm-pkg-popup__body"></div>' +
        '</div>' +
      '</div>'
    );
  }

  async function openProductPopup(handle) {
    renderPopup();
    var popup = qs('.mm-pkg-popup');
    var body = qs('.mm-pkg-popup__body', popup);
    popup.hidden = false;
    body.innerHTML = '<div class="mm-pkg-loading"><div class="mm-pkg-spinner"></div></div>';

    try {
      var product = productCache[handle];
      if (!product) {
        var res = await fetch('/products/' + handle + '.js');
        if (!res.ok) throw new Error('Product not found');
        product = await res.json();
        productCache[handle] = product;
      }
      var desc = product.description || '';
      if (desc.length > 1200) desc = desc.slice(0, 1200) + '…';
      body.innerHTML =
        (product.featured_image ? '<img class="mm-pkg-popup__img" src="' + product.featured_image + '" alt="">' : '') +
        '<h3 class="mm-pkg-popup__title">' + product.title + '</h3>' +
        '<div class="mm-pkg-popup__desc">' + desc + '</div>';
    } catch (e) {
      body.innerHTML = '<p class="mm-pkg-error">' + t('Could not load product info', 'تعذر تحميل معلومات المنتج') + '</p>';
    }
  }

  function closePopup() {
    var popup = qs('.mm-pkg-popup');
    if (popup) popup.hidden = true;
  }

  function render() {
    var title = state.builder ? (IS_AR && state.builder.titleAr ? state.builder.titleAr : state.builder.title) : '';
    var hero =
      '<div class="mm-pkg-hero">' +
        '<h1>' + title + '</h1>' +
        '<p>' + t('Build your perfect stack', 'صمّم بكتك المثالي') + '</p>' +
      '</div>';

    var content = '';
    if (state.phase === 'qty') content = renderQtyStep();
    else if (state.phase === 'pick') content = renderPickStep();
    else content = renderSummary();

    root.innerHTML = renderTopbar() + hero + renderProgress() + content;
    renderBar();
    renderPopup();
    bindEvents();
  }

  function bindEvents() {
    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = categories()[state.catIndex];
        if (!cat) return;
        state.quantities[cat.id] = parseInt(btn.dataset.qty, 10) || 0;
        render();
      });
    });

    root.querySelectorAll('[data-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = btn.dataset.nav;
        if (nav === 'prev-cat') {
          state.catIndex = Math.max(0, state.catIndex - 1);
        } else if (nav === 'next-cat') {
          if (state.catIndex < categories().length - 1) {
            state.catIndex++;
          } else {
            var needed = totalPicksNeeded();
            if (needed === 0) {
              alert(t('Select at least one item', 'اختر منتجاً واحداً على الأقل'));
              return;
            }
            state.phase = 'pick';
            state.pickIndex = 0;
          }
        } else if (nav === 'prev-pick') {
          state.pickIndex = Math.max(0, state.pickIndex - 1);
        } else if (nav === 'next-pick') {
          state.pickIndex++;
        } else if (nav === 'to-summary') {
          state.phase = 'summary';
        } else if (nav === 'edit-picks') {
          state.phase = 'pick';
          state.pickIndex = 0;
        }
        render();
      });
    });

    root.querySelectorAll('[data-info]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        openProductPopup(btn.dataset.info);
      });
    });

    root.querySelectorAll('[data-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.pick;
        var card = btn.closest('.mm-pkg-card');
        var pick = currentPick();
        if (!pick || !card) return;
        var cat = pick.category;
        var product = (cat.products || []).find(function (p) { return p.handle === handle; });
        if (!product) return;
        var sel = card.querySelector('.mm-pkg-variant-select');
        var variantId = sel ? sel.value : (product.variants && product.variants[0] ? product.variants[0].id : null);
        if (!variantId) return;
        setSelection(pick.categoryId, pick.slotIndex, product, variantId);
        var queue = buildPickQueue();
        if (state.pickIndex < queue.length - 1) {
          state.pickIndex++;
        } else {
          state.phase = 'summary';
        }
        render();
      });
    });

    root.querySelectorAll('[data-close-popup]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    var atcBtn = qs('[data-atc]');
    if (atcBtn) atcBtn.addEventListener('click', addToCart);
  }

  async function addToCart() {
    if (state.adding || !state.price || !state.selections.length) return;
    state.adding = true;
    renderBar();

    try {
      var groupId = 'pkg_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
      var offerId = state.offerId || state.builder.id;
      var props = {
        _offerId: offerId,
        _offerType: 'PACKAGE_BUILDER',
        _packageGroupId: groupId,
      };

      var items = state.selections.map(function (s) {
        return { id: parseInt(s.variantId, 10), quantity: 1, properties: props };
      });

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      if (!addRes.ok) throw new Error('Cart add failed');

      var discountPct = String(state.price.discountPercent || 0);
      var deals = state.selections.map(function (s) {
        return {
          variantId: s.variantId,
          discountPercent: discountPct,
          type: 'bundle',
          offerId: String(offerId),
          quantity: 1,
        };
      });

      var cart = await (await fetch('/cart.js')).json();
      var existing = [];
      try {
        existing = JSON.parse(cart.attributes._flash_deals_data || '[]');
      } catch (e) {}
      var merged = (window.MMOffers && window.MMOffers.mergeOfferDeals)
        ? window.MMOffers.mergeOfferDeals(existing, deals, offerId)
        : existing.filter(function (d) { return String(d.offerId) !== String(offerId); }).concat(deals);

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _flash_deals_data: JSON.stringify(merged) } }),
      });

      try {
        sessionStorage.setItem('mm_open_cart', '1');
      } catch (e) {}

      window.location.href = homeUrl;
    } catch (e) {
      console.error('[PackageBuilder] ATC error', e);
      alert(t('Could not add to cart. Try again.', 'تعذرت الإضافة للسلة. حاول مرة أخرى.'));
      state.adding = false;
      renderBar();
    }
  }

  async function init() {
    try {
      await fetchBuilder();
      render();
    } catch (e) {
      console.error('[PackageBuilder]', e);
      root.innerHTML =
        '<div class="mm-pkg-error">' +
          '<p>' + t('Package builder unavailable', 'مُخصص البكج غير متاح') + '</p>' +
          '<a href="' + homeUrl + '" class="mm-pkg-back">' + t('Back to store', 'العودة للمتجر') + '</a>' +
        '</div>';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
